//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss'
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const uncertain = useStore((state) => state.uncertain);
  const setUncertain = useStore((state) => state.setUncertain);

  const [next, setNext] = useState(uncertain.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setUncertain(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.uncertain.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={uncertain} onChange={handleChange}>
          <MultiOption value={"I haven't had much luck in the past"}>
            {t('onboarding.uncertain.options.luck')}
          </MultiOption>
          <MultiOption value={'Previous plans were too restrictive'}>
            {t('onboarding.uncertain.options.plans')}
          </MultiOption>
          <MultiOption value={"I worry I'll just gain the weight back"}>
            {t('onboarding.uncertain.options.weight')}
          </MultiOption>
          <MultiOption value={"I think I'll plateau"}>
            {t('onboarding.uncertain.options.plateau')}
          </MultiOption>
          <MultiOption value={'Bit worried about my motivation'}>
            {t('onboarding.uncertain.options.motivation')}
          </MultiOption>
          <MultiOption value={"The plan doesn't seem realistic"}>
            {t('onboarding.uncertain.options.notRealistic')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.uncertain.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'uncertain',
              answer: uncertain.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
